import React, { Fragment, useEffect, useState, useMemo, useCallback } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
import ModalImage from "react-modal-image";

import Flatpickr from "react-flatpickr";
import Select from "react-select";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { getPermissionCategory, resetPermissionCategoryState } from "../../../store/permissionCategory/action";
import { getEmployee, resetEmployeeState } from "../../../store/employee/action";
import { resetAttendanceState, getAttendance as onGetAttendances, addNewAttendance as onAddNewAttendance, updateAttendance as onUpdateAttendance, deleteAttendance as onDeleteAttendance, getAttendanceLoading } from "../../../store/attendance/action";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import defaultImg from "../../../assets/images/users/user-dummy-img.jpg";
import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import { api } from "../../../config";

import Leaflet from "leaflet";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import ExportDoc from "../../../Components/Common/ExportDoc";
import { setBranchSelect, setCompanySelect } from "../../../store/actions";

const Attendance = () => {
  const [modal, setModal] = useState(false);
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, employeeLoading, employees, attendances, isAttendanceCreated, isAttendanceSuccess, loading, error, permissionCategories, permissionCategoryLoading, clients, clientLoading, companies, companyLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    attendances: state.Attendance.attendances,
    isAttendanceCreated: state.Attendance.isAttendanceCreated,
    isAttendanceSuccess: state.Attendance.isAttendanceSuccess,
    loading: state.Attendance.loading,
    permissionCategories: state.PermissionCategory.permissionCategories,
    permissionCategoryLoading: state.PermissionCategory.loading,
    employees: state.Employee.employees,
    employeeLoading: state.Employee.loading,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    error: state.Attendance.error,
  }));

  const [attendanceList, setAttendanceList] = useState([]);
  const [attendance, setAttendance] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [permissionCategoryList, setPermissionCategoryList] = useState([]);
  const [approveModal, setApproveModal] = useState(false);
  const [info, setInfo] = useState([]);
  const [locationCord, setLocationCord] = useState([-6.4577368, 106.9776222]);

  const [isSearch, setIsSearch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [employeeList, setEmployeeList] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [companyList, setCompanyList] = useState([]);

  const [positionMessage, setPositionMessage] = useState("");
  const [defaultCompanyId, setDefaultCompanyId] = useState(null);

  const [pageIdx, setPageIdx] = useState(0);
  const [attendanceDoc, setAttendanceDoc] = useState([]);

  const typeOptionsList = [
    {
      label: "Jam Masuk",
      value: "clock_in",
    },
    {
      label: "Jam Pulang",
      value: "clock_out",
    },
    {
      label: "Jam Mulai Istirahat",
      value: "break_in",
    },
    {
      label: "Jam Selesai Istirahat",
      value: "break_out",
    },
    {
      label: "Jam Masuk Lembur",
      value: "over_in",
    },
    {
      label: "Jam Keluar Lembur",
      value: "over_out",
    },
  ];

  const onClickDelete = (attendance) => {
    setAttendance(attendance);
    setDeleteModal(true);
  };

  const handleDeleteAttendance = () => {
    if (attendance) {
      dispatch(onDeleteAttendance(attendance));
      setDeleteModal(false);
    }
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  useEffect(() => {
    setAttendanceList(attendances);
  }, [attendances]);

  useEffect(() => {
    if (companySelected) {
      setPositionMessage(`${userData?.user?.user_department && userData?.user?.user_department?.name}, ${userData?.user?.user_position && userData?.user?.user_position?.name}`);
      dispatch(resetAttendanceState());
      dispatch(onGetAttendances({ companyId: companySelected?.value ?? "" }));
      dispatch(resetPermissionCategoryState());
      dispatch(getPermissionCategory());
      handleGetEmployee(userData?.companyId);
    }
  }, [companySelected]);

  useEffect(() => {
    if (!isEmpty(attendances)) {
      setAttendanceList(attendances);
      setInfo(attendances[attendances.length - 1]);

      let location = attendances[attendances.length - 1].clocationin ? attendances[attendances.length - 1].clocationin.split(",") : [];
      setLocationCord([location[0] ? location[0] : 0, location[1] ? location[1] : 0]);
      setIsEdit(false);
    }
  }, [attendances]);

  useEffect(() => {
    setAttendanceList(attendances);
  }, [attendances]);

  useEffect(() => {
    if (!isEmpty(attendances)) setAttendanceList(attendances.map((el) => ({ ...el, isChecked: false })));
  }, [attendances]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "name",
        label: "Nama",
        isSelected: true,
        data: [],
      },
      {
        id: "code",
        label: "ID",
        isSelected: true,
        data: [],
      },
      {
        id: "attendance_day",
        label: "Hari",
        isSelected: true,
        data: [],
      },
      {
        id: "status_attend",
        label: "Status",
        isSelected: true,
        data: [],
      },
      {
        id: "clockinat",
        label: "Masuk",
        isSelected: true,
        data: [],
      },
      {
        id: "clockoutat",
        label: "Keluar",
        isSelected: true,
        data: [],
      },
      {
        id: "clocks",
        label: "Waktu",
        isSelected: true,
        data: [],
      },
    ];

    if (attendanceList.length > 0) {
      attendanceList.forEach((data) => {
        if (data.isChecked) {
          Object.entries(data).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);
            if (doc) {
              if (doc.id === "clocks") {
                doc.data.push(value ? value + " Jam" : "-");
              } else {
                doc.data.push(value);
              }
            } else {
              if (key === "id") {
                const statusAttend = dataDoc.find((d) => d.id === "status_attend");

                let status = "";
                if (!data.clockinat) {
                  status = "Absent";
                } else if (data.clockinat) {
                  if (!data.clockoutat) {
                    status = "Working";
                  } else {
                    status = "Present";
                  }
                } else {
                  status = "Present";
                }

                statusAttend.data.push(status);
              }
            }
          });
        }
      });
    }

    setAttendanceDoc(dataDoc);
  }, [attendanceList]);

  useEffect(() => {
    if (!isEmpty(permissionCategories)) {
      var permissionCategoryData = [];
      var opt = [];
      permissionCategories.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        const type = item.type;
        if (item.type === "attendance" || item.type === "timeoff") {
          var obj = {
            label: name,
            value: id,
            type: type,
          };
          opt.push(obj);
        }
      });
      var option = { options: opt };
      permissionCategoryData.push(option);
      setPermissionCategoryList(permissionCategoryData);
    }
  }, [permissionCategories]);

  const handleGetCompany = (id) => {
    dispatch(resetEmployeeState());
    validation.setFieldValue("employee", "");
    setEmployeeList([]);
  };

  const handleGetEmployee = (id) => {
    dispatch(resetEmployeeState());
    dispatch(getEmployee({ companyId: id }));
  };

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    var data = [];
    var opt = [];
    (companies || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (companies.length > 0) {
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    var data = [];
    var opt = [];
    employees.forEach((item, key) => {
      const name = item.name;
      const id = item.userId;
      const position = item?.employee_user?.user_position && item?.employee_user?.user_department ? { label: `${item?.employee_user?.user_position?.name}, ${item?.employee_user?.user_department?.name}`, value: item?.employee_user?.user_position?.id, departmentId: item?.employee_user?.user_department?.id } : "";
      let branchId = null;
      if (item?.employee_user?.user_location?.length > 0) {
        item?.employee_user?.user_location?.forEach((element) => {
          if (element.isPrimary) {
            branchId = element.branchId;
          }
        });
      }
      var obj = { label: name, value: id, position: position, branchId: branchId };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (employees.length > 0) {
      setEmployeeList(data);
    }
  }, [employees]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setAttendance(null);
    } else {
      setModal(true);
    }
  }, [modal]);

  const handleAttendanceClick = useCallback(
    (arg) => {
      const data = arg;

      setAttendance({
        id: data.id,
        startat: `${data.attendance_date} ${data.clockinat}`,
        client: data.task_client && {
          label: data.client_name ? data.client_name : "",
          value: data.clientId ? data.clientId : "",
        },
        company: data.task_company && {
          label: data.company_name ? data.company_name : "",
          value: data.companyId ? data.companyId : "",
        },
        employee: {
          label: data.name,
          value: data.userId,
          companyId: data.companyId,
          branchId: data.branchId,
        },
        permissionCategory: data.category && {
          label: data.category && data.category.name,
          value: data.category && data.category.id,
        },
      });
      setIsEdit(true);
      toggle();
    },
    [toggle, userType]
  );

  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteAttendance(element.value));
    });
    checkall.checked = false;
  };

  const handleApprovePermissionCategory = () => {
    if (attendance) {
      attendance.setApprove = true;
      dispatch(onUpdateAttendance(attendance));
      dispatch(resetAttendanceState());
      dispatch(onGetAttendances());
      setApproveModal(false);
    }
  };

  const checkedAll = () => {
    const allChecked = attendanceList.every((item) => item.isChecked);
    const updatedData = attendanceList.map((item) => ({
      ...item,
      isChecked: !allChecked,
    }));

    setAttendanceList(updatedData);
  };

  const columns = useMemo(
    () => [
      {
        id: "#",
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={attendanceList.every((item) => item.isChecked)} onChange={checkedAll} />,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          let location = data.clocationin ? data.clocationin.split(",") : [0, 0];
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <input
                type="checkbox"
                className="dataCheckbox me-2 form-check-input"
                checked={data.isChecked}
                onChange={() => {
                  const updatedData = attendanceList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
                  setAttendanceList(updatedData);
                }} />
              <ButtonGroup className="me-1">
                <UncontrolledButtonDropdown>
                  <Button
                    color="light"
                    className="btn-sm"
                    onClick={() => {
                      setInfo(data);
                      setLocationCord([location[0] ? location[0] : 0, location[1] ? location[1] : 0]);
                    }}>
                    <i className="ri-eye-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("updateAttendance") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      handleAttendanceClick(data);
                    }}>
                    <i className="ri-edit-2-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("deleteAttendance") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      onClickDelete(data);
                    }}>
                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                  </Button>
                </UncontrolledButtonDropdown>
              </ButtonGroup>
            </div>
          );
        },
      },
      {
        Header: "Karyawan",
        accessor: "name",
        filterable: true,
        Cell: (data) => {
          return (
            <div>
              <div className="mb-1">{data.row.original.name}</div>
              <div className="fs-10 text-muted">{data.row.original.group ? data.row.original.group.name : ""}</div>
            </div>
          );
        },
      },
      {
        Header: "ID",
        accessor: "code",
        filterable: true,
      },
      {
        id: "Group",
        Header: "Group",
        accessor: "code",
        filterable: true,
      },
      {
        id: "Hari",
        Header: "Hari",
        accessor: "attendance_day",
        filterable: true,
      },
      {
        Header: "Tanggal",
        accessor: "attendance_date",
        filterable: true,
        Cell: (data) => {
          return (
            <div>
              <div className="mb-1">{data.row.original.attendance_date}</div>
              <div className="text-muted fs-11">{data.row.original.attendance_day}</div>
            </div>
          );
        },
      },
      {
        Header: "Status",
        filterable: true,
        Cell: (data) => {
          if (data.row.original.category) {
            return <span className={`badge text-uppercase ${data.row.original.category.classname}`}>{data.row.original.category.name}</span>;
          }
          if (!data.row.original.clockinat || !data.row.original.clockinat || !data.row.original.clockinat) {
            return <span className="badge text-uppercase badge-soft-danger">Absent</span>;
          } else if (data.row.original.clockinat) {
            if (!data.row.original.clockoutat) return <span className="badge text-uppercase badge-soft-warning">Working</span>;
            else return <span className="badge text-uppercase badge-soft-info">Present</span>;
          } else {
            return <span className="badge text-uppercase badge-soft-info">Present</span>;
          }
        },
      },
      {
        Header: "Masuk",
        accessor: "clockinat",
        filterable: true,
      },
      {
        Header: "Keluar",
        accessor: "clockoutat",
        filterable: true,
      },
      {
        Header: "Waktu",
        accessor: "startat",
        filterable: true,
        Cell: (data) => <> {data.row.original.clocks ? data.row.original.clocks + " Jam" : "-"} </>,
      },
    ],
    [attendanceList, handleAttendanceClick, userType, userRole]
  );

  const defaultdate = () => {
    return moment().format("YYYY/MM/DD HH:mm:ss").toString();
  };

  const [filterDate, setFilterDate] = useState(null);

  const handleValidDate = (date) => {
    return moment(new Date(date), "YYYY/MM/DD").format("MMM D, YYYY");
  };

  const handleValidTime = (time) => {
    return moment(new Date(time), "YYYY/MM/DD").format("HH:mm");
  };

  //TABLE
  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: attendanceList,
      defaultColumn: { Filter: null },
      initialState: {
        hiddenColumns: ["Group", "Hari"],
        pageIndex: pageIdx,
        pageSize: 10,
        selectedRowIds: 0,
        // sortBy: [
        //   {
        //     desc: false,
        //   },
        // ],
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    setPageIdx(page);
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 600);

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }

    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      companyId: companySelected?.value ?? "",
    };
    dispatch(onGetAttendances(param));
  }

  const handleResetFilter = () => {
    setFilterDate(null);
    setAttendanceList([]);
    setSearchValue("");
    setGlobalFilter(undefined);
    dispatch(resetAttendanceState());
    dispatch(onGetAttendances({ companyId: companySelected?.value ?? "" }));
  };

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      client: (attendance && attendance.client) || clientSelected,
      company: (attendance && attendance.company) || companySelected,
      employee: (attendance && attendance.employee) ?? "",
      startat: (attendance && attendance.startat) ?? "",
      permissionCategory: (attendance && attendance.permissionCategory) ?? "",
      type: (attendance && attendance.type) ?? "",
    },
    validationSchema: Yup.object({
      permissionCategory: Yup.object().required("Please Pick permissionCategory"),
      employee: Yup.object().required("Please Pick Employee"),
      startat: Yup.string().required("Please Pick Effective Date"),
      //type: Yup.object().required("Please Pick Type"),
    }),
    onSubmit: (values) => {
      dispatch(getAttendanceLoading());
      if (isEdit) {
        const updateAttendance = {
          id: attendance ? attendance.id : 0,
          startat: values.startat,
          permissionCategoryId: values.permissionCategory.value,
          userId: values.employee.value,
          branchId: values.employee.branchId,
          companyId: values.company.value,
          clientId: values.client.value,
          type: values.type.value,
        };

        dispatch(onUpdateAttendance(updateAttendance));
        validation.resetForm();
      } else {
        const newAttendance = {
          startat: values.startat,
          permissionCategoryId: values.permissionCategory.value,
          userId: values.employee.value,
          branchId: values.employee.branchId,
          companyId: values.company.value,
          clientId: values.client.value,
          type: "clock_in",
        };
        dispatch(onAddNewAttendance(newAttendance));
        validation.resetForm();
      }
      toggle();
    },
  });

  document.title = "Kehadiran | Enterprise Resources Planning";

  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={attendanceList} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteAttendance} onCloseClick={() => setDeleteModal(false)} />
      <Container fluid>
        <BreadCrumb title="Opsi Penggajian" pageTitle="Kehadiran" loading={loading}>
          <div className="flex-shrink-0">
            <button
              type="button"
              className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createAttendance") !== -1 ? "btn btn-primary add-btn me-2" : "btn btn-primary add-btn me-2 d-none"}
              id="create-btn"
              onClick={() => {
                if (!isEdit) {
                  setAttendance((attendance) => ({
                    ...attendance,
                    type: typeOptionsList[0],
                  }));
                }
                setIsEdit(false);
                toggle();
              }}
            >
              <i className="ri-map-pin-time-line me-1 align-bottom fs-14"></i> Tambah
            </button>
            <ExportDoc data={attendanceDoc} />
          </div>
        </BreadCrumb>
        <Row>
          <Col xxl={8}>
            <Card id="attendanceList">
              <CardBody className="pt-0">
                <div>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={2}>
                            <div className="me-2 mb-2 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={5}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                            gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Cari...`}
                                value={searchValue ?? ""}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={3}>
                            <div className="search-box mb-2">
                              <Flatpickr
                                className="form-control"
                                id="datepicker-publish-input"
                                placeholder="Pilih Tanggal"
                                value={filterDate}
                                options={{
                                  mode: "range",
                                  dateFormat: "Y/m/d",
                                }}
                                onChange={(selectedDates, dateStr) => {
                                  setFilterDate(dateStr);
                                }}
                              />
                              <i className="bx bx-calendar-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={2}>
                            <div className="hstack gap-2">
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleFilter();
                                }}
                              >
                                <i className="ri-search-line align-bottom fs-16"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleResetFilter();
                                }}
                              >
                                <i className="mdi mdi-restore align-bottom fs-18"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          className="btn btn-light"
                          onClick={() => {
                            setPageIdx(pageIndex - 1);
                            previousPage();
                          }}
                          disabled={!canPreviousPage}
                        >
                          {" "}
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          className="btn btn-light"
                          onClick={() => {
                            setPageIdx(pageIndex + 1);
                            nextPage();
                          }}
                          disabled={!canNextPage}
                        >
                          {" "}
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Ubah Kehadiran" : "Tambah Kehadiran"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}>
                    <ModalBody>
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="row">
                            <div className="mb-3">
                              <Label htmlFor="client-field" className="form-label">
                                Grup Usaha&nbsp;
                                {clientLoading && (
                                  <Spinner color="primary" size="sm">
                                    Loading...
                                  </Spinner>
                                )}
                              </Label>
                              <Select
                                name="client"
                                value={validation.values.client}
                                isDisabled={userType === "admin" || userType === "client" ? false : true}
                                placeholder="Pilih Grup Usaha"
                                onChange={(e) => {
                                  validation.setFieldValue("client", e);
                                }}
                                options={clientList}
                              ></Select>
                            </div>

                            <div className="mb-3">
                              <Label htmlFor="company-field" className="form-label">
                                Perusahaan&nbsp;
                                {companyLoading && (
                                  <Spinner color="primary" size="sm">
                                    Loading...
                                  </Spinner>
                                )}
                              </Label>
                              <Select
                                name="company"
                                value={validation.values.company}
                                placeholder="Pilih Perusahaan"
                                isDisabled={userType === "admin" || userType === "client" ? false : true}
                                onChange={(e) => {
                                  dispatch(setBranchSelect(null));
                                  dispatch(setCompanySelect(e));
                                  validation.setFieldValue("company", e);
                                  handleGetEmployee(e.value);
                                }}
                                options={companyList}
                              ></Select>
                            </div>
                            <div className="mb-3">
                              <Label htmlFor="employee-field" className="form-label">
                                Karyawan <span className="text-danger">*</span>&nbsp;
                                {employeeLoading ? (
                                  <Spinner color="primary" size="sm">
                                    Loading...
                                  </Spinner>
                                ) : (
                                  ""
                                )}
                              </Label>
                              <Select
                                name="employee"
                                value={validation.values.employee}
                                placeholder="Pilih Karyawan"
                                isDisabled={employeeList.length > 0 ? false : true}
                                onChange={(e) => {
                                  validation.setFieldValue("oldposition", e.position);
                                  validation.setFieldValue("employee", e);
                                  // handleGetPosition(e.userId);
                                  // handleGetEmployee(e.value);
                                }}
                                options={employeeList}
                              ></Select>
                              {validation.touched.employee && validation.errors.employee ? (
                                <p className="invalid-feedback d-block" type="invalid">
                                  {validation.errors.employee}
                                </p>
                              ) : null}
                            </div>
                            <div className="mb-3">
                              <Label htmlFor="permissionCategory" className="form-label">
                                Kategori
                                {permissionCategoryLoading && (
                                  <Spinner color="primary" size="sm">
                                    Loading...
                                  </Spinner>
                                )}
                              </Label>
                              <Select
                                name="permissionCategory"
                                value={validation.values.permissionCategory}
                                placeholder="Pilih Kategori"
                                onChange={(e) => {
                                  validation.setFieldValue("permissionCategory", e);
                                }}
                                options={permissionCategoryList}
                                noOptionsMessage={(e) => "Type PermissionCategory to get option"}
                                invalid={validation.touched.permissionCategory && validation.errors.permissionCategory ? true : false}
                              ></Select>
                              {validation.touched.permissionCategory && validation.errors.permissionCategory ? (
                                <p className="text-danger" type="invalid">
                                  {validation.errors.permissionCategory}
                                </p>
                              ) : null}
                            </div>
                            {!!isEdit && (
                              <div className="mb-3">
                                <Label htmlFor="type" className="form-label">
                                  Tipe
                                </Label>
                                <Select
                                  name="type"
                                  value={validation.values.type}
                                  placeholder="Enter Jenis"
                                  onChange={(e) => {
                                    validation.setFieldValue("type", e);
                                  }}
                                  options={typeOptionsList}
                                  invalid={validation.touched.type && validation.errors.type ? true : false}></Select>
                                {validation.touched.type && validation.errors.type ? (
                                  <p className="text-danger" type="invalid">
                                    {validation.errors.type}
                                  </p>
                                ) : null}
                              </div>
                            )}
                            <div className="mb-3">
                              <Label htmlFor="date-field" className="form-label">
                                Tanggal Kehadiran
                              </Label>
                              <Flatpickr
                                name="startat"
                                className="form-control"
                                placeholder="Pilih Tanggal"
                                options={{ enableTime: true, time_24hr: true, altInput: true, altFormat: "Y/m/d H:i", dateFormat: "Y/m/d H:i" }}
                                value={validation.values.startat ?? ""}
                                onChange={(o, e) => {
                                  validation.setFieldValue("startat", e);
                                }}
                              />
                              {validation.touched.startat && validation.errors.startat ? (
                                <p className="text-danger" type="invalid">
                                  {validation.errors.startat}
                                </p>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                          }}
                        >
                          Tutup
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{"Simpan"}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="reason">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
              </CardBody>
            </Card>
          </Col>
          <Col xxl={4}>
            <Card>
              <CardBody className="text-center">
                <MapContainer center={locationCord} zoom={12} style={{ height: "300px" }}>
                  <TileLayer attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                  <Marker position={locationCord}>
                    <Popup>{info.branch_branch && info.branch_branch.name ? info.branch_branch.name : "-"}</Popup>
                  </Marker>
                </MapContainer>
              </CardBody>
              <div className="card-body">
                <div className="table-card p-2">
                  <table className="table table-responsive table-striped mb-3">
                    <tbody>
                      <tr>
                        <td className="p-2 pt-3 fw-medium text-primary text-uppercase" colSpan={"2"}>
                          Jadwal Kehadiran
                        </td>
                      </tr>
                      <tr>
                        <td className="p-2 w-50">Nama Jadwal</td>
                        <td className="p-2">{info.schedule_name}</td>
                      </tr>
                      <tr>
                        <td className="p-2">Kerja</td>
                        <td className="p-2">
                          {info.clockinat} - {info.clockoutat} {info.clocks && " | " + info.clocks + " Hour"}
                        </td>
                      </tr>
                      <tr>
                        <td className="p-2">Istirahat</td>
                        <td className="p-2">
                          {info.breakinat} - {info.breakoutat} {info.breaks && " | " + info.breaks + " Hour"}
                        </td>
                      </tr>
                      <tr>
                        <td className="p-2">Lembur</td>
                        <td className="p-2">
                          {info.overtimeinat} - {info.overtimeoutat} {info.overtime && " | " + info.overtime + " Hour"}
                        </td>
                      </tr>
                      <tr>
                        <td className="p-2">Grup Kerja</td>
                        <td className="p-2">{info.group ? info.group.name : ""} </td>
                      </tr>
                      <tr>
                        <td className="p-2">Lokasi Kerja</td>
                        <td className="p-2">
                          {info.branch ? info.branch.name : ""} {info.company_name}
                        </td>
                      </tr>
                      <tr>
                        <td className="" colSpan={"2"}></td>
                      </tr>
                      <tr>
                        <td className="p-2 pt-3 fw-medium text-primary text-uppercase" colSpan={"2"}>
                          Tangkapan Kamera
                        </td>
                      </tr>
                      <tr>
                        <td className="p-2">Wajah Masuk</td>
                        <td className="p-2">Wajah Keluar</td>
                      </tr>
                      <tr>
                        <td className={info.imageIn ? "p-2" : "d-none p-2"}>{info.imageIn && <ModalImage showRotate={true} small={`${api.MEDIA_URL}/media/${info.imageIn}-w-50`} large={`${api.MEDIA_URL}/media/${info.imageIn}`} alt={"imageIn"} className="img-fluid" />}</td>
                        <td className={info.imageOut ? "p-2" : "d-none p-2"}>{info.imageOut && <ModalImage showRotate={true} small={`${api.MEDIA_URL}/media/${info.imageOut}-w-50`} large={`${api.MEDIA_URL}/media/${info.imageOut}`} alt={"imageIn"} className="img-fluid" />}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Attendance;
